module.exports = __webpack_public_path__ + "static/ey-7-36a3ca3d21b0c31f2247ab30499b7031.png";